import React, { Component } from 'react'
import './index.scss'
import { Property } from 'csstype'

interface ITextConfig {
  text?: string
  textColor?: string
  fontSize?: number
  lineHeight?: number
  textAlign?: Property.TextAlign
  fontWeight?: Property.FontWeight
}
interface ITextProps {
  id: string
  pid?: string
  config: ITextConfig
}
const TextBox = (props: ITextProps) => {
  const { config } = props
  return (
    <div
      className="textContent"
      style={{
        color: config.textColor && config.textColor,
        fontSize: config.fontSize && config.fontSize + 'px',
        lineHeight: config?.lineHeight && config?.lineHeight + 'px',
        textAlign: config.textAlign,
        fontWeight: config.fontWeight,
      }}
    >
      {config.text}
    </div>
  )
}
export default TextBox
